import React, { Component } from "react";
import Layout from '../components/layout'
import Beta from '../components/Beta'
import Helmet from 'react-helmet'
import { translate } from "react-i18next"


class NotFoundPage extends Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this)
    this.state = {
      message: "",
      isApp: false,
    };
  }

  handler() {
    this.setState({
      isApp: false,
    })
  }

  render() {
    const { t } = this.props
      return (
        <Layout cl="" handler={this.handler}>
          <Helmet>
          <title>WFOW - {t("404_title", "Fehler 404")}</title>
          <meta name="description" content="Wir können die Seite, die du gesucht hast, leider nicht finden." />
          </Helmet> 
          <div id="main">
              <section id="banner">
                  <div className="inner">
                      <h1>{t("404_subtitle", "Diese Seite ist vom Netz gegangen")}</h1>
                      <p>{t("404_text", "Wir haben einen 404-Fehler und haben tief und weit geforscht, aber wir können die Seite, die du gesucht hast, leider nicht finden.")}</p>
                  </div>
              </section>
              <Beta />
          </div>
        </Layout>
      )
  }
}
export default translate("Index")(NotFoundPage)